var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ArtisanGrid',{ref:"shift",attrs:{"metaKey":"JyShiftInfo","query":_vm.query}})
}
var staticRenderFns = []

export { render, staticRenderFns }